<template>
  <div class="column content-box full_page page_container">
    <woot-button
      color-scheme="primary"
      :class-names="isMobile?'':'button--fixed-right-top'"
      icon="add-circle"
      @click="openAddPopup()"
    >
      {{ $t('ATTRIBUTES_MGMT.HEADER_BTN_TXT') }}
    </woot-button>
    <custom-attribute />
    <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
      <add-attribute :on-close="hideAddPopup" />
    </woot-modal>
  </div>
</template>

<script>
import AddAttribute from './AddAttribute';
import CustomAttribute from './CustomAttribute';
import responsiveMixin from 'shared/mixins/responsiveMixin.js';


export default {
  components: {
    AddAttribute,
    CustomAttribute,
  },
  mixins: [responsiveMixin],
  data() {
    return {
      showAddPopup: false,
    };
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
  },
};
</script>

<style></style>
